import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import ChangePasswordForm from './ChangePasswordForm';
import Preferences from './Preferences';
import ProfilePhotoUpload from './ProfilePhotoUpload';
import DemoReset from './DemoReset';
import CustomDialog from 'src/components/UI/dialog/CustomDialog';
import { useAutoTranslation } from 'src/hooks/useTranslate';

const MODAL_TYPES = {
  CHANGE_PASSWORD: 'changePassword',
  PREFERENCES: 'preferences',
  PROFILE_PHOTO: 'profilePhoto'
};

const defaultModalState = { open: false, type: null };

export default function MenuItems(props) {
  const [modal, setModal] = React.useState(defaultModalState);
  const t = useAutoTranslation();

  const openModal = (type) => setModal({ open: true, type });
  const closeModal = () => setModal(defaultModalState);

  return (
    <>
      <MenuItem onClick={() => openModal(MODAL_TYPES.PROFILE_PHOTO)}>
        {t(`Profile Photo`)}
      </MenuItem>
      <MenuItem onClick={() => openModal(MODAL_TYPES.CHANGE_PASSWORD)}>
        {t(`Change Password`)}
      </MenuItem>
      <MenuItem onClick={() => openModal(MODAL_TYPES.PREFERENCES)}>
        {t(`Preferences`)}
      </MenuItem>
      {/* demo tenant. */}
      <DemoReset />
      <CustomDialog
        title={'Change Password'}
        open={modal.open && modal.type === MODAL_TYPES.CHANGE_PASSWORD}
        handleClose={closeModal}
        minHeight="auto"
      >
        <ChangePasswordForm handleMenuClose={props.handleMenuClose} />
      </CustomDialog>
      <CustomDialog
        title={'Preferences'}
        open={modal.open && modal.type === MODAL_TYPES.PREFERENCES}
        handleClose={closeModal}
        minHeight="auto"
        maxWidth="md"
      >
        <Preferences />
      </CustomDialog>
      <CustomDialog
        title={'Profile Photo'}
        open={modal.open && modal.type === MODAL_TYPES.PROFILE_PHOTO}
        handleClose={closeModal}
        minHeight="auto"
        maxWidth="xs"
      >
        <ProfilePhotoUpload />
      </CustomDialog>
    </>
  );
}
